import React from 'react';
import { motion } from 'framer-motion';
import { Handshake, Landmark, MapPin } from 'lucide-react';
export function Commitments() {
  const commitments = [{
    number: '01',
    title: 'Keep Decisions Local',
    description: 'Protect the ability of communities to shape growth, neighborhoods, public safety, and quality of life.',
    icon: MapPin
  }, {
    number: '02',
    title: 'Work Across Differences',
    description: 'Back leaders who listen first and unite public, private, and nonprofit partners around practical progress.',
    icon: Handshake
  }, {
    number: '03',
    title: 'Stand Against Overreach',
    description: 'Defend the distinct roles of federal, state, and local government so power remains accountable.',
    icon: Landmark
  }];
  return <section id="commitments" className="py-24 bg-white scroll-mt-24" data-id="element-45" data-mp="2s74ceawv6cek">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-46" data-mp="2n92wtzyncv7u">
        <div className="text-center mb-16" data-id="element-47" data-mp="2exmfrkb92cnr">
          <p className="text-pac-red font-bold uppercase tracking-[0.2em] text-sm mb-3" data-id="element-48" data-mp="2eyxhlel4xac8">
            Our Promise
          </p>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-pac-navy mb-4" data-id="element-49" data-mp="2ju4g87zjroua">
            Three Commitments. One Arizona Promise.
          </h2>
          <div className="w-24 h-1 bg-pac-red mx-auto" data-id="element-50" data-mp="2tnbsmcspg53v" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-51" data-mp="2xo41v61kua05">
          {commitments.map((commitment, index) => <motion.article key={commitment.number} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-pac-navy text-white p-8 rounded-xl border-t-4 border-pac-gold" data-id="element-52" data-mp="32m5k5or6i5ak" data-mpi={index}>
              <div className="flex items-center justify-between mb-6" data-id="element-53" data-mp="1i6txcg0ug8it">
                <span className="font-serif text-5xl font-bold text-pac-gold" data-id="element-54" data-mp="1i97rmmnp9gpb">
                  {commitment.number}
                </span>
                <commitment.icon className="h-8 w-8 text-pac-gold" data-id="element-55" data-mp="157uh7tmz8c09" />
              </div>
              <h3 className="font-serif text-2xl font-bold mb-3" data-id="element-56" data-mp="1k4buiqeq80pg">
                {commitment.title}
              </h3>
              <p className="text-slate-300 leading-relaxed" data-id="element-57" data-mp="1f58wvr12swri">
                {commitment.description}
              </p>
            </motion.article>)}
        </div>
      </div>
    </section>;
}